import Repository from './repository'

const resource = '/uf'

export default {

  getId (id) {
    return Repository.get(`${resource}/${id}`)
  },
  getList () {
    return Repository.get(`${resource}/getlista`)
  },
  Update (data) {
    return Repository.post(`${resource}/editar/`, data)
  },
  Delete (data) {
    return Repository.post(`${resource}/excluir/`, data)
  },
  Save (data) {
    return Repository.post(`${resource}/save/`, data)
  },
}
